import { isBoolean } from '../../../utils/validators.js';
export function updateCommonConfigs(target, local, remote) {
    var _a, _b;
    // common.enableUsingDefaultUserProfile
    if (remote.common && isBoolean((_a = remote.common) === null || _a === void 0 ? void 0 : _a.enableUsingDefaultUserProfile)) {
        target.enableUsingDefaultUserProfile = remote.common.enableUsingDefaultUserProfile;
    }
    if (local.common && isBoolean((_b = local.common) === null || _b === void 0 ? void 0 : _b.enableUsingDefaultUserProfile)) {
        target.enableUsingDefaultUserProfile = local.common.enableUsingDefaultUserProfile;
    }
}
